import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Get, Post } from '../../utils/httpProvider';
import { QUANLYCONGVIEC_API } from '../../utils/apiUrl';

export const getDanhSachCongViecTongHopAction = createAsyncThunk(
  'quanLyCongViecTongHop/getDanhSach',
  async (filter, { rejectWithValue }) => {
    try {
      const url = QUANLYCONGVIEC_API.GET_TONG_HOP(filter);
      const res = await Get(url);
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const toggleQuanTamAction = createAsyncThunk(
  'quanLyCongViecTongHop/toggleQuanTam',
  async ({ workItemId, moduleType }, { rejectWithValue }) => {
    try {
      const url = QUANLYCONGVIEC_API.TOGGLE_QUAN_TAM(workItemId, moduleType);
      const res = await Post(url, null, {}); // No body needed, params in URL
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  data: [],
  totalRecords: 0,
  pageIndex: 1,
  pageSize: 20,
  loading: false,
  error: null,
};

export const quanLyCongViecTongHopSlice = createSlice({
  name: 'quanLyCongViecTongHop',
  initialState,
  reducers: {
    clearState: (state) => {
      state.data = [];
      state.totalRecords = 0;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDanhSachCongViecTongHopAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDanhSachCongViecTongHopAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data || action.payload?.Data || [];
        state.totalRecords = action.payload?.totalRecords || action.payload?.TotalRecords || 0;
        state.pageIndex = action.payload?.pageIndex || action.payload?.PageIndex || 1;
        state.pageSize = action.payload?.pageSize || action.payload?.PageSize || 20;
      })
      .addCase(getDanhSachCongViecTongHopAction.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.totalRecords = 0;
        state.error = action.payload || action.error;
      });
  }
});

export const { clearState } = quanLyCongViecTongHopSlice.actions;

export default quanLyCongViecTongHopSlice.reducer;
